import React, {memo, useEffect, useRef, useState} from "react";
import {Head} from "../../components";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {connect, useDispatch} from "react-redux";
import Button from "@mui/material/Button";
import {FETCH_SETTING} from "../../types";
import {Paper} from "@mui/material";
import {Loading} from './../../components'
import CurrencyFormat from "react-currency-format";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from "@mui/material/Checkbox";
import SunEditor,{buttonList} from "suneditor-react";

const Setting = memo((props) => {

    const { settingReducer, authReducer } = props;

    const dispatch = useDispatch();

    const initStat = {

    }

    const [form, setForm] = useState(initStat);
    const [check, setCheck] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setLoading(true);

        new Api().get('/setting').then((response) => {
            if (typeof response != "undefined") {
                dispatch({type: FETCH_SETTING, payload: response});
                let n_form = form;
                n_form['name'] = response.domain.name;
                n_form['meta_title'] = response.domain.meta_title;
                n_form['meta_description'] = response.domain.meta_description;
                n_form['introduce'] = response.domain.introduce;
                n_form['copy_right'] = response.domain.copy_right;
                n_form['blog_title'] = response.domain.blog_title;
                n_form['blog_description'] = response.domain.blog_description;


                n_form['shop_title'] = response.domain.shop_title;
                n_form['shop_description'] = response.domain.shop_description;
                n_form['free_postage'] = response.domain.free_postage;
                n_form['min_purchase'] = 1000;
                n_form['default_post_cost'] = response.domain.default_post_cost;

                n_form['gateway'] = response.domain.gateway;
                n_form['forwarding_types'] = response.domain.forwarding_types;

                setForm({...n_form});
            }

            setLoading(false);
        })
    }, []);

    const editor = useRef();
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };

    const handleChangeForwarding = (e , index) => {
        setCheck(!check)
        form['forwarding_types'][index][e.target.name] = ( +e.target.value === 0 ? 1 : 0 )
    }

    const handleChangeElementForwarding = (e , index) => {
        setCheck(!check)
        form['forwarding_types'][index][e.target.name] = e.target.value
    }

    const handleSubmit = (event) => {
        form["encrypt"] = true
        event.preventDefault();
        setLoading(true);

        new Api().put('/setting', form , false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }


    return(
        <Container>
            <Head data={{ 'link': '/setting', 'title': 'تنظیمات سایت'}} />
            <Box>
                <form onSubmit={handleSubmit}>
                    <Paper style={{ padding: '30px 20px'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="عنوان سایت"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.name}
                                    fullWidth
                                    name='name'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متا عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_title}
                                    fullWidth
                                    name='meta_title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    label="متا توضیحات"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_description}
                                    fullWidth
                                    name='meta_description'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}  >
                                <TextField
                                    label="متا عنوان وبلاگ"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.blog_title}
                                    fullWidth
                                    name='blog_title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}  >
                                <TextField
                                    label="متا توضیحات وبلاگ"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.blog_description}
                                    fullWidth
                                    name='blog_description'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{margin: '20px 0'}}>
                                {
                                    form.introduce !== undefined &&
                                    <SunEditor
                                        setOptions={{
                                            height: 200,
                                            buttonList: buttonList.complex
                                        }}
                                        height="300px"
                                        token={authReducer.token}
                                        getSunEditorInstance={getSunEditorInstance}
                                        defaultValue={form.introduce}

                                        value={form.introduce}
                                        onChange={(value) => {
                                            let n_form = form;
                                            n_form['introduce'] = value;
                                            setForm({...n_form});
                                        }}/>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متن کپی رایت"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.copy_right}
                                    fullWidth
                                    name='copy_right'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper style={{ padding: '30px 20px', marginTop: '15px'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}  >
                                <TextField
                                    label="متا عنوان فروشگاه"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.shop_title}
                                    fullWidth
                                    name='shop_title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}  >
                                <TextField
                                    label="متا توضیحات فروشگاه"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.shop_description}
                                    fullWidth
                                    name='shop_description'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper style={{ padding: '30px 20px', marginTop: '15px'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} >
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">درگاه بانکی</FormLabel>
                                    <RadioGroup aria-label="gender"  onChange={handleChangeElement} name="gateway" value={form.gateway ? form.gateway : 'sp'}>
                                        <FormControlLabel value="sp" control={<Radio />} label="سامان پرداخت کیش (سپ)" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper style={{ padding: '30px 20px', marginTop: '15px'}}>
                        <Grid container spacing={2}>
                            <Grid  xs={12}  >
                                <FormLabel component="legend">نحوه پرداخت</FormLabel>
                                {
                                    form.forwarding_types?.map((item , index) => {
                                        return (
                                            <Grid item xs={12} >
                                                <FormControlLabel
                                                    label={item.name}
                                                    control={
                                                        <Checkbox
                                                            name={"status"}
                                                            onChange={(e) => handleChangeForwarding(e ,index)}
                                                            value={item.status}
                                                            checked={+item.status === 1}
                                                        />
                                                    }
                                                />
                                                {
                                                    +item.status === 1 &&
                                                    <>
                                                        <Grid sm={12} container spacing={2}>
                                                            <Grid item sm={3} >
                                                                <TextField
                                                                    label="خرید پستی رایگان تهران (تومان)"
                                                                    variant="outlined"
                                                                    margin='dense'
                                                                    value={item.minimum_free_forwarding}
                                                                    fullWidth
                                                                    name='minimum_free_forwarding'
                                                                    onChange={(e) => handleChangeElementForwarding(e ,index)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                <CurrencyFormat value={item.minimum_free_forwarding} displayType={'text'} thousandSeparator={true}  />&nbsp;تومان
                                                            </Grid>
                                                            <Grid item sm={3} >
                                                                <TextField
                                                                    label="هزینه پست پیش فرض تهران (تومان)"
                                                                    variant="outlined"
                                                                    margin='dense'
                                                                    value={item.default_cost}
                                                                    fullWidth
                                                                    name='default_cost'
                                                                    onChange={(e) => handleChangeElementForwarding(e ,index)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                <CurrencyFormat value={item.default_cost} displayType={'text'} thousandSeparator={true}  />&nbsp;تومان
                                                            </Grid>
                                                            <Grid item sm={3}>
                                                                <TextField
                                                                    label="توضیحات"
                                                                    variant="outlined"
                                                                    margin='dense'
                                                                    value={item.description}
                                                                    fullWidth
                                                                    name='description'
                                                                    onChange={(e) => handleChangeElementForwarding(e ,index)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid sm={12} container spacing={2}>
                                                            <Grid item sm={3} >
                                                                <TextField
                                                                    label="خرید پستی رایگان شهرستان (تومان)"
                                                                    variant="outlined"
                                                                    margin='dense'
                                                                    value={item.town_minimum_free_forwarding}
                                                                    fullWidth
                                                                    name='town_minimum_free_forwarding'
                                                                    onChange={(e) => handleChangeElementForwarding(e ,index)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                {
                                                                    item.town_minimum_free_forwarding &&
                                                                        <>
                                                                            <CurrencyFormat value={item.town_minimum_free_forwarding} displayType={'text'} thousandSeparator={true}  />
                                                                            &nbsp;تومان
                                                                        </>
                                                                }
                                                            </Grid>
                                                            <Grid item sm={3} >
                                                                <TextField
                                                                    label="هزینه پست پیش فرض شهرستان (تومان)"
                                                                    variant="outlined"
                                                                    margin='dense'
                                                                    value={item.town_default_cost}
                                                                    fullWidth
                                                                    name='town_default_cost'
                                                                    onChange={(e) => handleChangeElementForwarding(e ,index)}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                />
                                                                {
                                                                    item.town_default_cost &&
                                                                        <>
                                                                            <CurrencyFormat value={item.town_default_cost} displayType={'text'} thousandSeparator={true}  />&nbsp;تومان
                                                                        </>
                                                                }
                                                            </Grid>

                                                        </Grid>
                                                    </>

                                                }
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    </Paper>
                    {Boolean(authReducer.user.permissions.setting.update_setting_admin.access) && <Grid item xs={12}>
                        <Button
                            disabled={loading}
                            style={{ marginTop: '15px'}}
                            type="submit"
                            variant="contained"
                            color={"primary"}
                        >
                            ذخیره تنظیمات
                        </Button>
                    </Grid>}
                </form>
                {loading && <Loading />}
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    authReducer: state.authReducer
})

export default connect(mapStateToProps)(Setting);